import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { Button, Layout } from 'antd';

import CabinetHeader from '../../../../components/Header';
import { Helmet } from '../../../../components/Helmet';

import SupportAskModal from './SupportAskModal';
import SupportFaq from './SupportFaq';

const { Content } = Layout;

const SupportPage = () => {
  const intl = useIntl();

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Layout className="support-page">
      <Helmet title={intl.formatMessage({ id: 'support.title' })} />

      <CabinetHeader />

      <Content
        className="support-page__content"
        aria-label={intl.formatMessage({ id: 'support.page.ariaLabel' })}
      >
        <h1 className="support-page__title">
          {intl.formatMessage({ id: 'support.title' })}
        </h1>

        <SupportFaq />

        <Button
          type="primary"
          className="support-page__ask-btn"
          onClick={() => setModalOpen(true)}
        >
          {intl.formatMessage({ id: 'support.askQuestion' })}
        </Button>
      </Content>

      <SupportAskModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </Layout>
  );
};

export default SupportPage;
